import { Grid, Typography, Box, Divider } from "@mui/material";
import { mediosMap, tarjetasMap } from "../../../../helpers/mediosPago";

const capitalize = (str = "") =>
  str.charAt(0).toUpperCase() + str.slice(1).replace(/([A-Z])/g, " $1");

/* 🟦 FUNCION ROBUSTA: Renderiza objetos, soporta anidados, vacíos y evita errores */
const renderKeyValue = (obj, parentKey = "") => {
  if (!obj || typeof obj !== "object") {
    return (
      <Grid item xs={12}>
        <Typography variant="body2">No hay datos</Typography>
      </Grid>
    );
  }

  const entries = Object.entries(obj);

  if (entries.length === 0) {
    return (
      <Grid item xs={12}>
        <Typography variant="body2">No hay datos</Typography>
      </Grid>
    );
  }

  return entries.flatMap(([key, value]) => {
    const displayKey = parentKey
      ? `${parentKey}: ${capitalize(key)}`
      : capitalize(key);

    if (value && typeof value === "object" && !Array.isArray(value)) {
      return renderKeyValue(value, displayKey);
    }

    // Mapear valores especiales
    const finalValue =
      key === "medioPago"
        ? mediosMap[value] ?? value
        : key === "Tarjeta"
        ? tarjetasMap[value] ?? value
        : value ?? "No especificado";

    return (
      <Grid item xs={6} key={displayKey + value}>
        <Typography variant="body2">
          <strong>{displayKey}:</strong> {String(finalValue)}
        </Typography>
      </Grid>
    );
  });
};

const DatosPagoCliente = ({ datosCli }) => {

  // Si no viene nada, mostrar modal vacío con mensaje
  if (!datosCli || typeof datosCli !== "object") {
    return (
      <Box sx={{ padding: 2 }}>
        <Typography variant="h6" gutterBottom>Datos del Pedido</Typography>
        <Typography>No hay datos para mostrar.</Typography>
      </Box>
    );
  }

  const {
    pago = null,
    obs_envio = null,
    mercadoPago = undefined,
  } = datosCli;

  return (
    <Box sx={{ padding: 2 }}>

      {/* 🟩 DATOS DE ENVÍO */}
      <Typography variant="h6" gutterBottom>Datos de Envío</Typography>
      <Grid container spacing={2}>
        {renderKeyValue(obs_envio)}
      </Grid>

      {/* 🟦 DATOS DE PAGO */}
      {(mercadoPago !== undefined || pago) && (
        <>
          <Divider sx={{ my: 3 }} />

          <Typography variant="h6" gutterBottom>Datos de Pago</Typography>

          <Grid container spacing={2}>
            
            {pago
              ? renderKeyValue(pago)
              : (
                <Grid item xs={12}>
                  <Typography>No hay datos de pago disponibles.</Typography>
                </Grid>
              )}
          </Grid>
        </>
      )}
    </Box>
  );
};

export default DatosPagoCliente;
